// Job service
import { apiRequest, API_URL } from "./api";

export const jobService = {
  createJob: async (
    name,
    email,
    contactNumber,
    description,
    images,
    jobType,
  ) => {
    const formData = new FormData();
    if (name) formData.append("name", name);
    formData.append("email", email);
    formData.append("contactNumber", contactNumber);
    formData.append("description", description);

    if (jobType) {
      formData.append("jobType", jobType);
    }

    if (images && images.length > 0) {
      images.forEach((image) => {
        formData.append("images", image);
      });
    }

    const response = await fetch(`${API_URL}/jobs`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to create job");
    }

    return await response.json();
  },

  getJobs: async () => {
    return await apiRequest("/jobs", {
      method: "GET",
      requiresAuth: true,
    });
  },

  getJob: async (id) => {
    return await apiRequest(`/jobs/${id}`, {
      method: "GET",
      requiresAuth: true,
    });
  },

  filterJobs: async (filters) => {
    const params = new URLSearchParams();
    if (filters.jobType) params.append("jobType", filters.jobType);
    if (filters.email) params.append("email", filters.email);
    if (filters.fromDate) params.append("fromDate", filters.fromDate);
    if (filters.toDate) params.append("toDate", filters.toDate);
    if (filters.search) params.append("search", filters.search);
    if (filters.assignedTo !== undefined && filters.assignedTo !== "") {
      params.append(
        "assignedTo",
        filters.assignedTo === null ? "unassigned" : String(filters.assignedTo),
      );
    }

    const queryString = params.toString();
    const endpoint = `/jobs/filter${queryString ? `?${queryString}` : ""}`;

    return await apiRequest(endpoint, {
      method: "GET",
      requiresAuth: true,
    });
  },

  updateJob: async (id, updates) => {
    return await apiRequest(`/jobs/${id}`, {
      method: "PUT",
      requiresAuth: true,
      body: JSON.stringify(updates),
    });
  },

  deleteJob: async (id) => {
    return await apiRequest(`/jobs/${id}`, {
      method: "DELETE",
      requiresAuth: true,
    });
  },

  contactMe: async (
    name,
    email,
    contactNumber,
    description,
    images,
    jobType,
  ) => {
    const formData = new FormData();
    if (name) formData.append("name", name);
    formData.append("email", email);
    formData.append("contactNumber", contactNumber);
    formData.append("description", description);
    if (jobType) formData.append("jobType", jobType);

    if (images && images.length > 0) {
      images.forEach((image) => {
        formData.append("images", image);
      });
    }

    const response = await fetch(`${API_URL}/jobs/contact-me`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to submit contact request");
    }

    return await response.json();
  },
};
